// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton--button--3p3qr","icon":"CloseButton--icon--32uGv"};